// extracted by mini-css-extract-plugin
export default {"body":"export_body__rFgc-","container":"export_container__97akv","spec":"export_spec__4bPpV","session":"export_session__IVgIY","transcribe":"export_transcribe__ztJmU"};